import { ReactElement, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { usePageViewAnalytics } from '@client/analytics/hooks';
import { TEALIUM_PAGE_TYPE } from '@client/analytics/types/types';
import { useTranslate } from '@client/i18n/hooks';
import cookie from 'js-cookie';
import { CHECKBOX_TOGGLE_STYLE, CheckboxToggle } from 'b2b-components/core/components/Form/Checkbox/CheckboxToggle';
import { DISABLED_TRACKING_COOKIE_NAME } from 'b2b-server/core/utils/constants';
import image from './assets/cookie.svg';
import './TrackingOptOutPage.scss';

export const TrackingOptOutPage = (): ReactElement => {
  const t = useTranslate();
  const { go } = useHistory();

  usePageViewAnalytics({
    pageType: TEALIUM_PAGE_TYPE.other,
  });

  const [state, setState] = useState(!cookie.get(DISABLED_TRACKING_COOKIE_NAME));

  const { host } = new URL(process.env.REACT_APP_URL_ROOT || '');

  const handleChange = (value: boolean) => {
    if (value) {
      cookie.remove(DISABLED_TRACKING_COOKIE_NAME, { domain: host });
    } else {
      cookie.set(DISABLED_TRACKING_COOKIE_NAME, '1', { expires: 365, domain: host });
    }
    setState(value);
    go(0);
  };

  return <div className='TrackingOptOutPage-Root'>
    <img
      src={image}
      className='TrackingOptOutPage-Image'
      alt={t('Cookie')}
    />

    <span className='TrackingOptOutPage-Title'>{t('Cookie Opt-Out')}</span>
    <div className='TrackingOptOutPage-Text'>
      <p>{t('We use technologies such as cookies or targeting and process personal data such as IP address or browser information to personalize the ads we display. These technologies help us measure results or better target our website content.')}</p>
      <p>{t('You can change/revoke this consent at any time later by changing the setting below.')}</p>
    </div>


    <div className='TrackingOptOutPage-TogglerContainer'>
      <span className='TrackingOptOutPage-TogglerContainerLabel'>
        {t('Website tracking is:')}
      </span>
      <CheckboxToggle
        onChange={handleChange}
        isChecked={state}
        label={state ? t('Active') : t('Inactive')}
        style={state ? CHECKBOX_TOGGLE_STYLE.SUCCESS : CHECKBOX_TOGGLE_STYLE.DEFAULT}
      />
    </div>

  </div>;
};
